/**
 * Product Form Components
 *
 */
function handleize(str) {
  return str
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]+/g, '-')  // replace non-alphanumeric with hyphen
    .replace(/^-+|-+$/g, '');     // trim hyphens from start/end
}

class ProductForm extends HTMLElement {
  constructor() {
    super();
    this.form = this.querySelector("form");
    this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
    this.cartElement = document.querySelector("ajax-cart");

    this.qtyBtns = this.querySelectorAll("[data-qty-btn]");
    this.qtyBtns.forEach((qtyBtn) =>
      qtyBtn.addEventListener("click", this.manageQtyBtn.bind(this))
    );
  }

  /**
   * Product Form Submit event
   *
   * @param {evt} Event instance
   */
  onSubmitHandler(evt) {
    evt.preventDefault();
    const addItems = [];
    const submitButton = this.querySelector('[type="submit"]');
    const productHandle = submitButton.getAttribute('data-handle');
    const qtyInput = this.querySelector("[data-qty-input]");
    const MainId = this.querySelector('[name="id"]').value;
    let timestamp = new Date().valueOf();
    const pdpContainer = this.closest(".product-details-wrapper");
    const obj = JSON.parse(serializeForm(this.form));

    submitButton.setAttribute("disabled", true);
    submitButton.classList.add("loading");

    if (pdpContainer) {
      if (obj.properties == undefined) {
        obj.properties = {};
      }
      if (
        pdpContainer.querySelectorAll("[data-bundle-selection]").length > 0 ||
        pdpContainer.querySelectorAll("[data-free-product]").length > 0
      ) {
        Object.assign(obj.properties, { timestamp: timestamp });
      }
    }
    document
      .querySelectorAll(`[data-specifications-content="${productHandle}"] tr`)
      .forEach(function (target) {
        var labelID =
          "_" +
          target
            .querySelector("th")
            .innerText.replace(":", "")
            .replaceAll(" ", "-")
            .trim();
        var labelValue = target.querySelector("td").innerText;
        let valuesArray = labelValue.split(",");
        valuesArray = valuesArray.map((value) => value.trim());
        let cleanValueString = valuesArray.join(", ").trim();

        obj.properties[labelID] = cleanValueString;
      });

    addItems.push(obj);

    // addItems.push(JSON.parse(serializeForm(this.form)))
    if (pdpContainer) {
      let addOnItemsEle = pdpContainer.querySelectorAll(
        "[data-addon-selection]:checked"
      );
      addOnItemsEle.forEach((addOn) => {
        if (!addOn.disabled) {
          let addOnParent = addOn.closest("addons-form");
          let addOnJSON = {
            id: addOnParent.querySelector(".variant--id").value,
            quantity: addOnParent.querySelector(".product-quantity").value,
          };
          addItems.push(addOnJSON);
        }
      });
    }

    // for bundle products
    if (pdpContainer && pdpContainer.querySelectorAll("[data-bundle-selection]").length > 0) {
      let bundleItemsEle = pdpContainer.querySelectorAll(
        "[data-bundle-selection]"
      );

      bundleItemsEle.forEach((bundle) => {
        if (bundle.getAttribute("data-bundle-selection") == true) {
          let bundleID = bundle.querySelector(".variant--id").value;
          let bundleQTY = bundle.querySelector(".variant--qty").value;
          let bundleJSON = {
            id: bundleID,
            quantity: bundleQTY,
            properties: {
              productType: "subProduct",
              mainProductId: MainId,
              timestamp: timestamp,
            },
          };
          addItems.push(bundleJSON);
        }
      });
    }

    const body = JSON.stringify({
      items: addItems,
    });

    fetch(`${routes.cart_add_url}`, { ...fetchConfig(), body })
      .then((response) => response.json())
      .then(() => {
        if (document.querySelector("#PopupModal-quickshop")) {
          document
            .querySelector("#PopupModal-quickshop .close-quickshop")
            .dispatchEvent(new Event("click"));
        }
        this.cartElement.getCartData("open_drawer");
        if (qtyInput) qtyInput.value = 1;
      })
      .catch((e) => {
        Rollbar.error("error while adding product", e);
        console.error(e);
      })
      .finally(() => {
        submitButton.classList.remove("loading");
        submitButton.removeAttribute("disabled");
      });
  }

  /**
   * Product Form Quantity Input update action
   *
   * @param {event} Event instance
   */
  manageQtyBtn(event) {
    event.preventDefault();
    let currentTarget = event.currentTarget;
    let action = currentTarget.dataset.for || "increase";
    let $qtyInput = currentTarget
      .closest("[data-qty-container]")
      .querySelector("[data-qty-input]");
    let currentQty = parseInt($qtyInput.value) || 1;
    let finalQty = 1;
    let decreaseQtyBtn = currentTarget
      .closest("[data-qty-container]")
      .querySelector('[data-for="decrease"]');

    if (action == "decrease" && currentQty <= 1) {
      if (decreaseQtyBtn) decreaseQtyBtn.classList.add("disabled");
      return false;
    } else if (action == "decrease") {
      finalQty = currentQty - 1;
      finalQty == 1
        ? decreaseQtyBtn.classList.add("disabled")
        : decreaseQtyBtn.classList.remove("disabled");
    } else {
      if (decreaseQtyBtn) decreaseQtyBtn.classList.remove("disabled");
      finalQty = currentQty + 1;
    }

    $qtyInput.value = finalQty;
  }
}
customElements.define("product-form", ProductForm);

/**
 * Dropdown selection for options
 */
class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.form = this.closest("form") || this.closest(".form-element");
    this.formType = this.form.dataset.format;
    this.addBtn = this.form.querySelector('[name="add"]');
    this.variant_json = this.form.querySelector("[data-variantJSON]");
    this.variantPicker = this.dataset.type;

    this.productJson = {};
    this.inventoryJson = [];
    if (this.form.querySelector("[data-productJSON]") != null) {
      this.productJson = JSON.parse(
        this.form.querySelector("[data-productJSON]").innerText
      );
    }
    if (
      this.form.querySelectorAll("[data-inventory-variant-json]").length > 0
    ) {
      for (var item of this.form.querySelectorAll(
        "[data-inventory-variant-json]"
      )) {
        if (item.innerText != "") {
          this.inventoryJson.push(JSON.parse(item.innerText));
        }
      }
    }

    if (this.formType == "product-page") this.onVariantChange("load");
    this.addEventListener("change", this.onVariantChange.bind(this));
    this._bindSoldoutEvent();
  }

  /**
   * Trigger this function variant is changed
   * @param {event} _event
   */
  onVariantChange(_event) {
    this.setCurrentVariant();
    if (this.formType == "product-page")
      window.globalVariables.product.currentVariant = this.currentVariant;

    if (!this.currentVariant) {
      this.toggleAddButton("disable");
      // Variant name update
      let options = this.form.querySelectorAll("[data-optionindex]");
      options.forEach((option) => {
        let lableID = "option" + option.dataset.optionindex;
        const selectedValue = option.querySelector(
          'input[type="radio"]:checked'
        );
        const lable = option.querySelector(".selected-option");
        if (!lable || !lableID || !selectedValue) return;
        lable.innerHTML = selectedValue.value;
      });
    } else {
      if (this.formType == "grid") {
        const productGrid = this.closest("[data-product-grid]");
        this.renderProductInfo(this.currentVariant, productGrid);
        this._updateLinks(productGrid);
      } else {
        const productPage = this.closest("[data-product-container]");
        this.renderProductInfo(this.currentVariant, productPage);
      }
      this.updateURLandID(this.currentVariant);
      this.toggleAddButton("enable");
      this.form.querySelector(".btn-submit")?.click();
    }
    this._bindSoldoutEvent();
  }

  /**
   * For linked option
   */
  _bindSoldoutEvent() {
    const productWrap = this.closest(".product-form");
    Shopify.optionsMap = {};
    this.defaultProductOptionSetup(productWrap);
    this.checkOptionSelection(productWrap);
    let var_id = this.closest("form").querySelector('[name="id"]').value;
    if (this.inventoryJson != undefined) {
      for (var item of this.inventoryJson) {
        if (parseInt(item.variant.id) == parseInt(var_id)) {
          if (
            item.variant_inventory_quantity <=
            parseInt(
              this.closest("form").querySelector("[data-qty-input]").value
            )
          ) {
            this.closest("form").querySelector("[data-qty-input]").value =
              item.variant_inventory_quantity;
            if (item.variant_inventory_quantity == 1) {
              this.closest("form")
                .querySelector(".btn-decrease")
                ?.closest("[data-qty-btn]")
                .classList.add("disabled");
            } else {
              this.closest("form")
                .querySelector(".btn-decrease")
                ?.closest("[data-qty-btn]")
                .classList.remove("disabled");
            }
            this.closest("form")
              .querySelector(".btn-increase")
              ?.closest("[data-qty-btn]")
              .classList.add("disabled");
          } else {
            this.closest("form")
              .querySelector(".btn-increase")
              ?.closest("[data-qty-btn]")
              .classList.remove("disabled");
          }
        }
      }
    }
  }
  defaultProductOptionSetup(productData) {
    Shopify.arrayIncludes = function (e, t) {
      for (var n = 0; n < e.length; n++) if (e[n] == t) return !0;
      return !1;
    };

    Shopify.uniq = function (e) {
      for (var t = [], n = 0; n < e.length; n++)
        Shopify.arrayIncludes(t, e[n]) || t.push(e[n]);
      return t;
    };

    if (
      productData
        .closest("product-form")
        .querySelector("[data-variantJSON]") != null
    ) {
      var productVariants = JSON.parse(
        productData
          .closest("product-form")
          .querySelector("[data-variantJSON]").innerText
      );
      var productOptions = this.productJson?.product.options;

      for (var i = 0; i < productVariants.length; i++) {
        var variant = productVariants[i];

        if (variant.available && productOptions != undefined) {
          // Gathering values for the 1st drop-down.
          if (productOptions.length === 1) {
            Shopify.optionsMap["root"] = Shopify.optionsMap["root"] || [];
            Shopify.optionsMap["root"].push(variant.option1);
            Shopify.optionsMap["root"] = Shopify.uniq(
              Shopify.optionsMap["root"]
            );
          }

          // Gathering values for the 2nd drop-down.
          if (productOptions.length > 1) {
            var key = variant.option1;
            Shopify.optionsMap[key] = Shopify.optionsMap[key] || [];
            Shopify.optionsMap[key].push(variant.option2);
            Shopify.optionsMap[key] = Shopify.uniq(Shopify.optionsMap[key]);
          }

          // Gathering values for the 3rd drop-down.
          if (productOptions.length === 3) {
            var key = variant.option1 + " / " + variant.option2;
            Shopify.optionsMap[key] = Shopify.optionsMap[key] || [];
            Shopify.optionsMap[key].push(variant.option3);
            Shopify.optionsMap[key] = Shopify.uniq(Shopify.optionsMap[key]);
          }
        }
      }
    }
  }
  // add disable class to input label
  addDisableClassToOptionLable(productData) {
    var optionData = productData.querySelectorAll(
      "form .product-form__input"
    );
    var optionListData = productData.querySelectorAll(
      "form .custom--select"
    );

    if (optionData.length > 0) {
      optionData.forEach((el, i) => {
        var optionElement = el.querySelectorAll(".list-unstyled li");
        if (optionElement.length > 0) {
          optionElement.forEach((item, i) => {
            item.querySelector("label").classList.add("is--disable");
          });
        }
      });
    }

    if (optionListData.length > 0) {
      optionListData.forEach((el, i) => {
        var optionElement = el.querySelectorAll(".list-unstyled li");
        if (optionElement.length > 0) {
          optionElement.forEach((item, i) => {
            item.classList.add("is--disable");
          });
        }
      });
    }
  }
  checkOptionSelection(productData) {
    this.addDisableClassToOptionLable(productData);
    var optionsCount = productData.querySelectorAll(
      "form .product-form__input"
    ).length;
    if (optionsCount > 0) {
      if (optionsCount === 1) {
        if (Shopify.optionsMap["root"]) {
          Shopify.optionsMap["root"].forEach((el, i) => {
            productData
              .querySelector(
                `form .product-form__input .list-unstyled label[title="${handleize(el)}"]`
              )
              ?.closest("li")
              .classList.remove("is--disable");
            productData
              .querySelector(
                `form .custom--select .list-unstyled label[title="${handleize(el)}"]`
              )
              ?.closest("li")
              .classList.remove("is--disable");
          });
        }
      } else if (optionsCount === 2) {
        var option_1 = productData
          .querySelectorAll("form .product-form__input")[0]
          .querySelector(".list-unstyled input:checked").value;
        var option_2 = productData.querySelector(
          "form .product-form__input:last-child .list-unstyled input:checked"
        ).value;

        if (Shopify.optionsMap[option_1] != undefined) {
          Shopify.optionsMap[option_1].forEach((el, i) => {
            productData
              .querySelector(
                `form .product-form__input .list-unstyled label[title="${handleize(el)}"]`
              )
              ?.closest("li")
              .classList.remove("is--disable");
            productData
              .querySelector(
                `form .custom--select .list-unstyled label[title="${handleize(el)}"]`
              )
              ?.closest("li")
              .classList.remove("is--disable");
          });
        }

        for (var key in Shopify.optionsMap) {
          if (Shopify.optionsMap[key].indexOf(option_2) != -1) {
            productData
              .querySelector(
                `form .product-form__input .list-unstyled label[title="${handleize(key)}"]`
              )
              ?.closest("li")
              .classList.remove("is--disable");
            productData
              .querySelector(
                `form .custom--select .list-unstyled label[title="${handleize(key)}"]`
              )
              ?.closest("li")
              .classList.remove("is--disable");
          }
        }
      } else if (optionsCount === 3 && Shopify.optionsMap) {
        var option_1 = productData
          .querySelectorAll("form .product-form__input")[0]
          .querySelector(".list-unstyled input:checked").value;
        var option_2 = productData
          .querySelectorAll("form .product-form__input")[1]
          .querySelector(".list-unstyled input:checked").value;
        var option_3 = productData.querySelector(
          "form .product-form__input:last-child .list-unstyled input:checked"
        ).value;

        if (Shopify.optionsMap[option_1] != undefined) {
          Shopify.optionsMap[option_1].forEach((el, i) => {
            var option2 = Shopify.optionsMap[option_1][i];
            productData
              .querySelector(
                `form .product-form__input .list-unstyled label[title="${option2}"]`
              )
              ?.closest("li")
              .classList.remove("is--disable");
            productData
              .querySelector(
                `form .custom--select .list-unstyled label[title="${option2}"]`
              )
              ?.closest("li")
              .classList.remove("is--disable");
          });
        }

        var option2Data = `${option_1} / ${option_2}`;

        Shopify.optionsMap[option2Data].forEach((el, i) => {
          var option3 = Shopify.optionsMap[option2Data][i];
          productData
            .querySelector(
              `form .product-form__input .list-unstyled label[title="${option3}"]`
            )
            ?.closest("li")
            .classList.remove("is--disable");
          productData
            .querySelector(
              `form .custom--select .list-unstyled label[title="${option3}"]`
            )
            ?.closest("li")
            .classList.remove("is--disable");
        });

        for (var key in Shopify.optionsMap) {
          if (Shopify.optionsMap[key].indexOf(option_2) != -1) {
            productData
              .querySelector(
                `form .product-form__input .list-unstyled label[title="${handleize(key)}"]`
              )
              ?.closest("li")
              .classList.remove("is--disable");
            productData
              .querySelector(
                `form .custom--select .list-unstyled label[title="${handleize(key)}"]`
              )
              ?.closest("li")
              .classList.remove("is--disable");
          }
        }

        var customOption1 = [];
        var firstSwatchOptions = productData.querySelectorAll(
          "form .product-form__input:first-child .list-unstyled li"
        );
        if (firstSwatchOptions.length > 0) {
          firstSwatchOptions.forEach((optionEl, i) => {
            customOption1.push(
              optionEl.querySelector("label").getAttribute("title")
            );
          });
        }
        customOption1.forEach((el, i) => {
          var customOptionName = `${el} / ${option_2}`;
          if (
            Shopify.optionsMap[customOptionName] != undefined &&
            Shopify.optionsMap[customOptionName].indexOf(option_3) != -1
          ) {
            productData
              .querySelector(
                `form .product-form__input .list-unstyled label[title="${el}"]`
              )
              ?.closest("li")
              .classList.remove("is--disable");
          } else {
            productData
              .querySelector(
                `form .product-form__input .list-unstyled label[title="${el}"]`
              )
              ?.closest("li")
              .classList.add("is--disable");
          }
        });

        var customOption2 = [];
        var firstSwatchOptions = productData.querySelectorAll(
          "form .product-form__input:nth-child(2) .list-unstyled li"
        );
        if (firstSwatchOptions.length > 0) {
          firstSwatchOptions.forEach((optionEl, i) => {
            customOption2.push(
              optionEl.querySelector("label").getAttribute("title")
            );
          });
        }
        customOption2.forEach((el, i) => {
          var customOption2Name = `${option_1} / ${el}`;
          if (
            Shopify.optionsMap[customOption2Name] != undefined &&
            Shopify.optionsMap[customOption2Name].indexOf(option_3) != -1
          ) {
            productData
              .querySelector(
                `form .product-form__input .list-unstyled label[title="${el}"]`
              )
              ?.closest("li")
              .classList.remove("is--disable");
          } else {
            productData
              .querySelector(
                `form .product-form__input .list-unstyled label[title="${el}"]`
              )
              ?.closest("li")
              .classList.add("is--disable");
          }
        });
      }
    }
  }

  /**
   * Change product variant url link in product card when variant is being updated
   * @param {element} productGrid
   */
  _updateLinks(productGrid) {
    if (!this.currentVariant || !productGrid) return;
    const variantURL = "?variant=" + this.currentVariant.id;
    const formLinks = productGrid.querySelectorAll(".product-link");
    formLinks.forEach((link) => {
      let href = link.href.split("?")[0];
      link.href = href + variantURL;
    });
  }

  /**
   * Fetch selected options from dropdown
   */
  _getOptionsFromSelect() {
    let options = [];
    this.querySelectorAll(".variant_selector").forEach((selector) => {
      options.push(selector.value);
    });
    return options;
  }

  /**
   * Fetch selected options from radio
   */
  _getOptionsFromRadio() {
    const fieldsets = Array.from(
      this.querySelectorAll("fieldset:not(.addon-fieldset)")
    );
    return fieldsets.map((fieldset) => {
      return Array.from(
        fieldset.querySelectorAll("input:not(.addon-swatch)")
      ).find((radio) => radio.checked).value;
    });
  }

  /**
   * change value of currentVariant when variant being changed
   */
  setCurrentVariant() {
    // get all current values from selectors
    this.currentVariant = false;
    let options =
      this.variantPicker == "variant-select"
        ? this._getOptionsFromSelect()
        : this._getOptionsFromRadio();

    let variantsArray = this._getVariantData();
    variantsArray.find((variant) => {
      // get true or false based on options value presented in variant
      // value format would be [true/false,true/fasle,true/false] boolean value based on options present or not
      let mappedValues = variant.options.map((option, index) => {
        return options[index] === option;
      });

      // assign variant details to this.currentVariant if all options are present
      if (!mappedValues.includes(false)) {
        this.currentVariant = variant;
      }
    });
  }

  /**
   * Update URL on variant change event
   * @param {JSON} currentVariant
   */
  updateURLandID(currentVariant) {
    if (!currentVariant) return;

    // update query string with latest variant ID
    if (this.formType == "product-page")
      window.history.replaceState(
        {},
        "",
        `${this.dataset.url}?variant=${currentVariant.id}`
      );

    // update variant input with currentVariant Id
    const input = this.form.querySelector('input[name="id"]');
    input.value = currentVariant.id;
  }

  /**
   * Render Product data based on current variant
   * @param {event} currentVariant
   * @param {element} container
   */
  renderProductInfo(currentVariant, container) {
    if (!currentVariant || !container) return;

    // Price Update
    let price = Shopify.formatMoney(
      currentVariant.price,
      window.globalVariables.money_format
    );
    let compare_price = Shopify.formatMoney(
      currentVariant.compare_at_price,
      window.globalVariables.money_format
    );
    let priceElement = container.querySelector("[data-currentPrice]");
    let comparePriceElement = container.querySelector("[data-comparePrice]");

    if (priceElement) priceElement.innerHTML = price;
    if (comparePriceElement) {
      comparePriceElement.innerHTML = compare_price;
      if (currentVariant.compare_at_price <= 0) {
        comparePriceElement.style.display = "none";
      } else {
        comparePriceElement.style.display = "block";
      }
    }

    if (container.querySelector(".product_sku") != null) {
      if (currentVariant.sku != "") {
        container.querySelector(".product_sku").innerHTML =
          "SKU: " + currentVariant.sku;
        container.querySelector(".product_sku").classList.remove("d-none");
      } else {
        container.querySelector(".product_sku").classList.add("d-none");
      }
    }

    // Grid Image Update on variant selection
    if (this.formType == "grid") {
      if (!currentVariant.featured_image) return;
      const featuredImage = container.querySelector("[data-feauredImage]");
      let updatedSrc = currentVariant.featured_image.src;
      if (updatedSrc) {
        featuredImage.src = updatedSrc;
        featuredImage.srcset = updatedSrc;
      }
    } else {
      if (currentVariant.featured_image) {
        let imageID = currentVariant.featured_media.id;
        let imageSlide = document.querySelector(
          `.product--media[data-mediaID="${imageID}"]`
        );
        if (this.formType == "quickshop") {
          imageSlide = document.querySelector(
            `.quickshop-slider .product--media[data-mediaID="${imageID}"]`
          );
        }
        if (imageSlide) {
          let slideIndex = Array.from(imageSlide.parentNode.children).indexOf(
            imageSlide
          );
          if (quickShopSlider) quickShopSlider.slideTo(slideIndex, 2000, true);
          else if (productSlider) productSlider.slideTo(slideIndex, 2000, true);
        }
      }
    }

    // Variant name update
    let options = this.form.querySelectorAll("[data-optionindex]");
    options.forEach((option) => {
      // let lableID = "option" + option.dataset.optionindex;
      // const lable = option.querySelector(".selected-option");
      // if (!lable || !lableID) return;
      // lable.innerHTML = currentVariant[lableID];

      let labelID = "option" + option.dataset.optionindex;

      const selectedValue = option.querySelector(
        'input[type="radio"]:checked'
      );
      let options_in = this.form.querySelectorAll(`[data-optionindex="${option.dataset.optionindex}"]`);
      options_in.forEach((option) => {
        if (selectedValue != null && option.closest('custom-select') != null)
          option.closest('custom-select').querySelector(".selected-option").innerHTML = selectedValue.value;
      });
      
      let label = option.querySelector(".selected-option");
      if (!label || !labelID || !selectedValue) return;
      label.innerHTML = selectedValue.value;
    });
  }

  /**
   * Toggle the button based on product availability ( add to cart / soldOut )
   * @param {*} status enable / disable
   */
  toggleAddButton(status) {
    if (!this.addBtn) return;

    if (status == "disable") {
      this.addBtn.setAttribute("disabled", true);
      this.addBtn.classList.add("disabled-btn");
      if (this.addBtn.querySelector(".add-text"))
        this.addBtn.querySelector(".add-text").textContent =
          window.variantStrings.unavailable;
    } else if (this.currentVariant && !this.currentVariant.available) {
      this.addBtn.setAttribute("disabled", true);
      this.addBtn.classList.add("disabled-btn");
      if (this.addBtn.querySelector(".add-text"))
        this.addBtn.querySelector(".add-text").textContent =
          window.variantStrings.soldOut;
    } else {
      this.addBtn.removeAttribute("disabled");
      this.addBtn.classList.remove("disabled-btn");
      if (this.form.classList.contains("cart-upsell-form")) {
        this.addBtn.querySelector(".add-text").textContent =
          window.variantStrings.upsellAddText;
      } else {
        this.addBtn.querySelector(".add-text").textContent =
          window.variantStrings.addToCart;
      }
    }
  }

  /**
   * Store the all the variants json
   */
  _getVariantData() {
    this.variantData =
      this.variantData || JSON.parse(this.variant_json.textContent);
    return this.variantData;
  }
}

customElements.define("variant-selects", VariantSelects);

/**
 * Radio Button swatch
 */
class VariantRadios extends VariantSelects {
  constructor() {
    super();

    this.form = this.closest("form") || this.querySelector(".form-element");
    this.formType = this.form.dataset.format;

    const colorSwatchContainer = this.querySelector(".color-swatch");
    if (colorSwatchContainer) {
      const colorSwatches = colorSwatchContainer.querySelectorAll(".swatch");
      colorSwatches.forEach((swatch) => {
        let colorHandle = swatch.querySelector('input[type="radio"]').dataset
          .handle;
        let swatchStyle = Utility.getSwatchStyle(colorHandle);
        swatch
          .querySelector(".swatch-label")
          .setAttribute("style", swatchStyle);
      });
    }
  }
}
customElements.define("variant-radios", VariantRadios);
